<div class="container-datos-extra-facultad">
  

    <div class="width-paginate container-carreras-grado" *ngIf="info">
             <hr class="divider"  [style.background-color]="info?.venue?.color">

            <section class="seccion-posgrados">
                <div class="bloque-posgrado"  *ngFor="let item of info?.schoolInformation?.items">
                    <h2 #blockTitle class="subtitle-oferta  quicksand-bold" [style.color]="info?.venue?.color"> {{item.title}}</h2>

                    <div class="contenido-bloque">
                        <div class="contenedor-imagen imagen-bloque">
                            <img  class="desk" onerror="this.src='./assets/img/default.png'" [src]="item.path" alt="UCA Posgrados">
                            <img  class="mob" onerror="this.src='./assets/img/default.png'" [src]="item.pathMobile" alt="UCA Posgrados">
                        </div>
                  
                        <div class="info-bloque">
                            <p #description class="texto-descripcion nunito-medium">
                                {{item.description}}
                            </p>
                            <a [href]="url(item.link)" target="_blank" rel="noopener noreferrer">
                              <button class="btn-posgrado nunito-medium zoomIn"> + INFO</button>
                            </a>         
                        </div>
                    </div>
                </div>
             
            </section>
    </div>
